import NewMedicalDocument from "../utils/medicalDocument/new";
import { prescriptionModule } from "../prescriptions/new";
import { useOrderModule } from "../orders/new";

const NewCombinedMedicalDocument = () => (
  <NewMedicalDocument modules={[prescriptionModule, useOrderModule()]} />
);

export default NewCombinedMedicalDocument;
